import React from 'react';

export function CampCard({
  children,
  className = '',
  padding = true,
  ...props
}) {
  return (
    <section
      className={[
        'rounded-camp-lg border border-camp-100',
        'bg-camp-surface shadow-camp-sm',
        padding ? 'p-5' : '',
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </section>
  );
}

export function CampCardHeader({ children, className = '', ...props }) {
  return (
    <div className={`mb-4 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CampCardTitle({ children, className = '', ...props }) {
  return (
    <h2
      className={`text-lg font-bold tracking-tight text-camp-green-deep ${className}`}
      {...props}
    >
      {children}
    </h2>
  );
}

export function CampCardDescription({ children, className = '', ...props }) {
  return (
    <p className={`mt-1 text-sm text-camp-gray ${className}`} {...props}>
      {children}
    </p>
  );
}

export function CampCardContent({ children, className = '', ...props }) {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}
